export class TypingUser {
    constructor({ userId, content, isTyping }) {
        this.userId = void 0;
        this.content = void 0;
        this.isTyping = void 0;
        this.userId = userId;
        this.content = content;
        this.isTyping = isTyping;
    }
}
